import { render, staticRenderFns } from "./RemoveDevice.vue?vue&type=template&id=bf242f7a&scoped=true&"
import script from "./RemoveDevice.vue?vue&type=script&lang=js&"
export * from "./RemoveDevice.vue?vue&type=script&lang=js&"
import style0 from "./RemoveDevice.vue?vue&type=style&index=0&id=bf242f7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf242f7a",
  null
  
)

export default component.exports